import React, { useState, useEffect } from 'react';
import Button from '../../../../components/ui/Button';
import DeliveryMethodSelection from '../shared/DeliveryMethodSelection';
import { formatCurrency } from '../../../../utils/formatters';

const SwapActions = ({ product, onAddToCart }) => {
  const [swapProducts, setSwapProducts] = useState([]);
  const [deliveryOption, setDeliveryOption] = useState(null);

  // Initialize delivery option if not already set - MUST BE BEFORE CONDITIONAL RETURN
  useEffect(() => {
    if (!product) return;
    
    const { openToShipping, openToPickUp } = product;
    if (deliveryOption === null) {
      if (openToShipping) {
        setDeliveryOption('shipping');
      } else if (openToPickUp) {
        setDeliveryOption('pickup');
      }
    }
  }, [product, deliveryOption]);

  if (!product || !product.openToSwap) return null;

  const { 
    openToPickUp, 
    openToShipping,
    pickUpAddress,
    shippingCost = 5.99, // Default estimated shipping cost until real calculation is implemented
    currency = 'USD'
  } = product;

  return (
    <div className="space-y-6 max-w-md">
      <div className="bg-gray-50 p-4 rounded-lg">
        <p className="text-sm text-gray-600">
          Propose a swap with one of your items
        </p>
      </div>

      {/* Delivery Options */}
      <DeliveryMethodSelection
        openToShipping={openToShipping}
        openToPickUp={openToPickUp}
        deliveryOption={deliveryOption}
        setDeliveryOption={setDeliveryOption}
        pickUpAddress={pickUpAddress}
        shippingCost={shippingCost}
        currency={currency}
      />

      <div className="mx-auto w-full">
        <Button
          variant="primary"
          className="w-full"
        >
          Select Item
        </Button>

        {swapProducts.length === 0 ? (
          <div className="text-center mt-4 text-sm text-gray-500">
            No items selected for swap yet
          </div>
        ) : (
          <div className="mt-4 space-y-4">
            {/* Selected swap items would go here */}
            <div className="text-center text-sm text-gray-500">
              {swapProducts.length} items selected
            </div>
          </div>
        )}

        {swapProducts.length > 0 && (
          <div className="mt-6">
            <Button
              variant="orange"
              className="w-full"
              disabled={!deliveryOption}
              onClick={() => {
                onAddToCart?.({
                  type: 'swap',
                  swapProducts,
                  deliveryOption,
                  navigateToCart: true
                });
              }}
            >
              Swap Now
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SwapActions; 